import SwipeCarousel from './SwipeCarousel';

export default SwipeCarousel;
